module.exports = __webpack_public_path__ + "img/goldregen-2020-109.b68ef384.jpg";